export default function selector(storeState) {
    const inventoryPredictions = _.get(storeState, `resources.inventoryPredictions`, {});
    const { gisDoohMapToken } = inventoryPredictions;
    return {
        gisDoohMapToken,
    };
}
